import React, { FunctionComponent } from 'react';
import PublicationsPages from 'apps/publications/pages';
import ErrorBoundary from 'core/components/error-boundary';
import GlobalStyle from 'ui/styles/global';
import history from 'core/routing/history';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import store from 'store';
import 'ui/styles/style.scss';

const PublicationsApp: FunctionComponent = () => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <ErrorBoundary>
          <GlobalStyle />
          <PublicationsPages />
        </ErrorBoundary>
      </Router>
    </Provider>
  );
};

export default PublicationsApp;
